module.exports = __webpack_public_path__ + "img/footer_icon_tiktok.40cc1c40.svg";